import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

/**
 * ナビゲーションバーの通知情報
 */
export interface INavbarNoticeState {
	/** 処理待ち 受講承認数 */
	waitingStudentApprovalCnt?: number;
	/** 処理待ち 受講取消数 */
	waitingStudentCancelCnt?: number;
	/** 処理待ち 実績承認数 */
	waitingPerformanceApprovalCnt?: number;

	/** 申請中 受講申請カリキュラム数 */
	applyingStudentApplyCurriculumCnt?: number;
	/** 申請中 受講申請研修数 */
	applyingStudentApplyTrainingCnt?: number;
	/** 申請中 取消申請カリキュラム数 */
	applyingCancelApplyCurriculumCnt?: number;
	/** 申請中 取消申請研修数 */
	applyingCancelApplyTrainingCnt?: number;
	/** 申請中 実績申請研修数 */
	applyingPerformanceApplyTrainingCnt?: number;

	/** 設定日時 */
	setNoticeAt?: Date;
}

/**
 * スマホで利用情報
 */
export interface IShowEmQrCodeInit {
	/** QRコード */
	qrCodeBase64?: string;
	/** QRコードURL */
	emRegistrationUrl?: string;
	/** 登録有効期限 */
	registrationExpirationDate?: string;
	/** テナントID */
	emTenantId?: string;
	/** 法人コード */
	companyCode?: string;
	/** Generalist/EMのログインID */
	userId?: string;
	/** Generalist/EMのログインURL */
	signinUrl?: string;
	/** 連携結果 */
	resultFlg?: boolean;
	/** エラーメッセージ */
	errorMessageList?: string[];
}

/** ナビゲーションバーアクションクリエータ */
export const setNavbarNotices = actionCreator<{
	noticeState: INavbarNoticeState;
}>('SET_NAVBAR_NOTICES');

export const showNavbarProgress = actionCreator<{
	isShow: boolean;
}>('SHOW_NAVBAR_PROGRESS');

export const showEmCooperation = actionCreator<{
	isShowEmCooperation: boolean;
}>('SHOW_NAVBAR_EMCOOPERATION');

export const showEmQrCodeInit = actionCreator<{
	emQrCodeInit: IShowEmQrCodeInit;
}>('SHOW_NAVBAR_EM_QR_CODE');



// WEBPACK FOOTER //
// ./src/actions/navbar.ts